import { CompanyKPIs } from "./CompanyKPIs";
import { CompanyActivityChart } from "./CompanyActivityChart";
import { CompanyAttention } from "./CompanyAttention";
import { CompanyRecentCompleted } from "./CompanyRecentCompleted";
import { CompanySpacesGrid } from "./CompanySpacesGrid";
import { CompanyRoutines } from "./CompanyRoutines";

export function CompanyDashboard() {
  return (
    <div className="company-page">
      <header className="company-header">
        <h1 className="company-title">Компания</h1>
        <p className="company-subtitle">
          Обзор всех пространств: что делают агенты, где нужны решения,
          какие автоматизации работают.
        </p>
      </header>

      <CompanyKPIs />

      <CompanyActivityChart />

      <section className="company-live-cols">
        <CompanyAttention />
        <CompanyRecentCompleted />
      </section>

      <CompanySpacesGrid />

      <CompanyRoutines />
    </div>
  );
}
